import { render, staticRenderFns } from "./prescriptionData.vue?vue&type=template&id=6056c74c&scoped=true&"
import script from "./prescriptionData.vue?vue&type=script&lang=js&"
export * from "./prescriptionData.vue?vue&type=script&lang=js&"
import style0 from "./prescriptionData.vue?vue&type=style&index=0&id=6056c74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6056c74c",
  null
  
)

export default component.exports